export const GoogleMapApiConfig = 'AIzaSyCWTd8Bk9enX-j4lzSPWBDRQGim3XLGF2s';